import { apiFetch } from "./api";

export type AIPersona = "ADMIN" | "HR" | "SUPERVISOR" | "EMPLOYEE";
export type AIFeedbackValue = "HELPFUL" | "NOT_HELPFUL" | "INCORRECT";

export interface AskBody {
  persona: AIPersona;
  message: string;
  sessionId?: string;
}

export interface AskResult {
  interactionId: string;
  answer: string;
  tokensUsed: number;
}

export interface AIHistoryItem {
  id: string;
  question: string;
  answer: string;
  persona: AIPersona;
  feedback: AIFeedbackValue | null;
  tokensUsed: number | null;
  createdAt: string;
}

export interface AIHistoryPage {
  data: AIHistoryItem[];
  total: number;
  page: number;
  pageSize: number;
}

export const aiAssistantApi = {
  /** Read-only admin Q&A over scoped aggregates (FEAT-2026-011). */
  ask: (body: AskBody) =>
    apiFetch<AskResult>(`/ai-assistant/ask`, { method: "POST", body }),

  /** The caller's own past interactions, newest first. */
  history: (params: { page?: number; pageSize?: number } = {}) => {
    const usp = new URLSearchParams();
    if (params.page) usp.set("page", String(params.page));
    if (params.pageSize) usp.set("pageSize", String(params.pageSize));
    const qs = usp.toString();
    return apiFetch<AIHistoryPage>(`/ai-assistant/history${qs ? `?${qs}` : ""}`);
  },

  feedback: (id: string, feedback: AIFeedbackValue) =>
    apiFetch<{ id: string; feedback: AIFeedbackValue }>(`/ai-assistant/${id}/feedback`, {
      method: "PATCH",
      body: { feedback },
    }),
};
